import AjaxUtils from "../utils/ajax-utils";

const RelevantContent = {
    post_id: script_var.post_id,
    ajax_url: script_var.ajax_url,
    $containers: document.querySelectorAll('.js-relevant-content'),

    init() {
        this.$containers.forEach($container => {
            this.initContainer($container);
        });
    },

    initContainer($container) {
        const that = this;
        const $buttons = $container.querySelectorAll('[data-relevant-content-button]');

        $buttons.forEach($button => {
            $button.addEventListener('click', e => {
                const type = $button.dataset.relevantContentButton === 'like' ? 'like' : 'dislike';

                $container.classList.add('loading');

                AjaxUtils.postData(that.ajax_url, {
                    action: 'add_relevant_content_' + type,
                    post_id: that.post_id,
                })
                .then(response => {
                    if (response.success === true) {
                        $container.parentNode.removeChild($container);
                    } else {
                        console.error(response.data.error_message);

                        $container.classList.remove('loading');
                    }
                }).catch(error => {
                    $container.parentNode.removeChild($container);
                });
            });
        });
    }
}

export default RelevantContent;